import api from "../axios/api";
import { ISite } from "../models/isite";
import siteObjectToQuery from "../utils/siteObjectToQuery";
import filterObjectToQuery from "../utils/filterObjectToQuery";
import { IPayload } from "../models/ipayload";
import { IEquipment } from "../models/iequipment";
import Axios from "axios";
let CancelToken = Axios.CancelToken;
let fetchEquipments_cancel: any;
let fetchEquipmentsById_cancel: any;
let fetchEquipmentsExport_cancel: any;


export const fetchEquipmentsService = (page: number, limit: number, search: string, order: string, orderBy: string, sites: Array<ISite>, filteredPlaces: any, filteredModels: any, filteredGroups: any, filteredAreas: any, filteredCompanies: any, filteredStatus: any, filterDeletedEquipments: boolean): Promise<IPayload<IEquipment>> => {
  fetchEquipments_cancel && fetchEquipments_cancel()

  let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
  queryParams += `${filteredModels && filteredModels.length > 0 ? '&models=' + filterObjectToQuery(filteredModels) : ''}`
  queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
  queryParams += `${filteredGroups && filteredGroups.length > 0 ? '&groups=' + filterObjectToQuery(filteredGroups) : ''}`
  queryParams += `${filteredAreas && filteredAreas.length > 0 ? '&areas=' + filterObjectToQuery(filteredAreas) : ''}`
  queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? '&companies=' + filterObjectToQuery(filteredCompanies) : ''}`
  queryParams += `${filterDeletedEquipments ? '&showDeletedEquipments=' +  filterDeletedEquipments : ''}`

  if (filteredStatus) {
    const valid = filteredStatus.valid;
    const validWithOpenedActions = filteredStatus.validWithOpenedActions;
    const maintenance = filteredStatus.maintenance;
    const inactive = filteredStatus.inactive;
    const invalidInDelay = filteredStatus.invalid.inDelay;
    const invalidNotDone = filteredStatus.invalid.notDone;
    const invalidHasActionsOpenedOrOverdue = filteredStatus.invalid.hasActionsOpenedOrOverdue;
    const invalidHasNoServices = filteredStatus.invalid.hasNoServices;
    const invalid = (invalidInDelay || invalidNotDone || invalidHasActionsOpenedOrOverdue || invalidHasNoServices);

    const allStatus = (!valid && !validWithOpenedActions && !maintenance && !inactive && !invalidInDelay && !invalidNotDone && !invalidHasActionsOpenedOrOverdue && !invalidHasNoServices)
      || (valid && validWithOpenedActions && maintenance && !inactive && invalidInDelay && invalidNotDone && invalidHasActionsOpenedOrOverdue && invalidHasNoServices);
    
    if (!allStatus) {
      let status = '';
      let statusReason = '';
      status += valid ? 'valid|' : '';
      status += maintenance ? 'maintenance|' : '';
      status += inactive ? 'inactive|' : '';
      status += invalid ? 'invalid|' : '';
      status += validWithOpenedActions ? 'validWithOpenedActions|' : '';

      statusReason += invalidInDelay ? 'inDelay|' : '';
      statusReason += invalidNotDone ? 'notDone|' : '';
      statusReason += invalidHasActionsOpenedOrOverdue ? 'hasActionsOpenedOrOverdue|' : '';
      statusReason += invalidHasNoServices ? 'hasNoServices' : '';

      queryParams += (status !== '') ? `&status=${status}` : '';
      queryParams += (statusReason !== '') ? `&statusReason=${statusReason}` : '';
    };
  };

  return api.get('/equipments' + queryParams, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipments_cancel = c;
    })
  })
}

export const fetchEquipmentsExportService = (search: string, order: string, orderBy: string, sites: Array<ISite>, filteredPlaces: any, filteredModels: any, filteredGroups: any, filteredAreas: any, filteredCompanies: any, filteredStatus: any, emailLanguage: any): Promise<IPayload<IEquipment>> => {
  fetchEquipmentsExport_cancel && fetchEquipmentsExport_cancel()

	let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
	queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
	queryParams += `${filteredModels && filteredModels.length > 0 ? '&models=' + filterObjectToQuery(filteredModels) : ''}`
	queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
	queryParams += `${filteredGroups && filteredGroups.length > 0 ? '&groups=' + filterObjectToQuery(filteredGroups) : ''}`
  queryParams += `${filteredAreas && filteredAreas.length > 0 ? '&areas=' + filterObjectToQuery(filteredAreas) : ''}`
  queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? '&companies=' + filterObjectToQuery(filteredCompanies) : ''}`
  queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;

  if (filteredStatus) {
    const valid = filteredStatus.valid;
    const maintenance = filteredStatus.maintenance;
    const inactive = filteredStatus.inactive;
    const invalidInDelay = filteredStatus.invalid.inDelay;
    const invalidNotDone = filteredStatus.invalid.notDone;
    const invalidHasActionsOpenedOrOverdue = filteredStatus.invalid.hasActionsOpenedOrOverdue;
    const invalidHasNoServices = filteredStatus.invalid.hasNoServices;
    const invalid = (invalidInDelay || invalidNotDone || invalidHasActionsOpenedOrOverdue || invalidHasNoServices);

    const allStatus = (!valid && !maintenance && !inactive && !invalidInDelay && !invalidNotDone && !invalidHasActionsOpenedOrOverdue && !invalidHasNoServices)
      || (valid && maintenance && inactive && invalidInDelay && invalidNotDone && invalidHasActionsOpenedOrOverdue && invalidHasNoServices);
    
    if (!allStatus) {
      let status = '';
      let statusReason = '';
      status += valid ? 'valid|' : '';
      status += maintenance ? 'maintenance|' : '';
      status += inactive ? 'inactive|' : '';
      status += invalid ? 'invalid|' : '';

      if (filteredStatus.invalid.mixed) {
        statusReason += invalidInDelay ? 'inDelay ' : '';
        statusReason += invalidNotDone ? 'notDone ' : '';
        statusReason += invalidHasActionsOpenedOrOverdue ? 'hasActionsOpenedOrOverdue' : '';
        statusReason = statusReason.trim().replace(' ', '-') + '|';
      }

      if (!filteredStatus.invalid.mixed) {
        statusReason += invalidInDelay ? 'inDelay|' : '';
        statusReason += invalidNotDone ? 'notDone|' : '';
        statusReason += invalidHasActionsOpenedOrOverdue ? 'hasActionsOpenedOrOverdue|' : '';
      }

      statusReason += invalidHasNoServices ? 'hasNoServices' : '';

      queryParams += (status !== '') ? `&status=${status}` : '';
      queryParams += (statusReason !== '') ? `&statusReason=${statusReason}` : '';
    };
  };

	return api.get('/equipments/export' + queryParams, {
		cancelToken: new CancelToken(function executor(c) {
			fetchEquipmentsExport_cancel = c;
		})
	})

}

export const fetchEquipmentsExportByPlaceService = (placeId: string, search: string, filteredModels: any, filteredGroups: any, filteredAreas: any, filteredCompanies: any, filteredStatus: any, emailLanguage: string): Promise<IPayload<IEquipment>> => {
  fetchEquipmentsExport_cancel && fetchEquipmentsExport_cancel()

	let queryParams = `?q=${search ? search : ''}`;
	queryParams += `${filteredModels && filteredModels.length > 0 ? '&models=' + filterObjectToQuery(filteredModels) : ''}`
	queryParams += `${'&leafs=' + placeId}`
	queryParams += `${filteredGroups && filteredGroups.length > 0 ? '&groups=' + filterObjectToQuery(filteredGroups) : ''}`
  queryParams += `${filteredAreas && filteredAreas.length > 0 ? '&areas=' + filterObjectToQuery(filteredAreas) : ''}`
  queryParams += `${filteredCompanies && filteredCompanies.length > 0 ? '&companies=' + filterObjectToQuery(filteredCompanies) : ''}`
  queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;

  if (filteredStatus) {
    const valid = filteredStatus.valid;
    const maintenance = filteredStatus.maintenance;
    const inactive = filteredStatus.inactive;
    const invalidInDelay = filteredStatus.invalid.invalidInDelay;
    const invalidNotDone = filteredStatus.invalid.invalidNotDone;
    const invalidHasActionsOpenedOrOverdue = filteredStatus.invalid.invalidHasActionsOpenedOrOverdue;
    const invalidHasNoServices = filteredStatus.invalid.invalidHasNoServices;
    const invalid = (invalidInDelay || invalidNotDone || invalidHasActionsOpenedOrOverdue || invalidHasNoServices);

    const allStatus = (!valid && !maintenance && !inactive && !invalidInDelay && !invalidNotDone && !invalidHasActionsOpenedOrOverdue && !invalidHasNoServices)
      || (valid && maintenance && inactive && invalidInDelay && invalidNotDone && invalidHasActionsOpenedOrOverdue && invalidHasNoServices);
    
    if (!allStatus) {
      let status = '';
      let statusReason = '';
      status += valid ? 'valid|' : '';
      status += maintenance ? 'maintenance|' : '';
      status += inactive ? 'inactive|' : '';
      status += invalid ? 'inactive|' : '';


      if (filteredStatus.invalid.mixed) {
        statusReason += invalidInDelay ? 'inDelay ' : '';
        statusReason += invalidNotDone ? 'notDone ' : '';
        statusReason += invalidHasActionsOpenedOrOverdue ? 'hasActionsOpenedOrOverdue' : '';
        statusReason = statusReason.trim().replace(' ', '-') + '|';
      }

      if (!filteredStatus.invalid.mixed) {
        statusReason += invalidInDelay ? 'inDelay|' : '';
        statusReason += invalidNotDone ? 'notDone|' : '';
        statusReason += invalidHasActionsOpenedOrOverdue ? 'hasActionsOpenedOrOverdue|' : '';
      }

      statusReason += invalidHasNoServices ? 'hasNoServices' : '';

      queryParams += (status !== '') ? `&status=${status}` : '';
      queryParams += (statusReason !== '') ? `&statusReason=${statusReason}` : '';
    };
  };

	return api.get('/equipments/export' + queryParams, {
		cancelToken: new CancelToken(function executor(c) {
			fetchEquipmentsExport_cancel = c;
		})
	})
}


export const fetchEquipmentsByIdService = (id: string): Promise<IEquipment> => {
  fetchEquipmentsById_cancel && fetchEquipmentsById_cancel()

  return api.get('/equipments/' + id, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipmentsById_cancel = c;
    })
  })
}

export const fetchEquipmentsByIdWithServicesReplicateService = (id: string): Promise<IEquipment> => {
  fetchEquipmentsById_cancel && fetchEquipmentsById_cancel()

  return api.get(`/equipments/${id}/servicesReplicated`, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipmentsById_cancel = c;
    })
  })
}

export const fetchEquipmentServices = (id: string) => {
  fetchEquipmentsById_cancel && fetchEquipmentsById_cancel()

  return api.get(`/equipments/${id}/equipmentservices`, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipmentsById_cancel = c;
    })
  })
}
